import isArray from 'lodash/isArray';
import isDate from 'lodash/isDate';
import isEmpty from 'lodash/isEmpty';
import isNaN from 'lodash/isNaN';
import { RegisterOptions } from 'react-hook-form';

import { TFunction } from 'i18next';

export const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const emailValidation = (value: string) => {
  return emailPattern.test(value);
};

const messages = {
  required: 'common.forms.validation.required',
  number: 'common.forms.validation.number',
  email: 'common.forms.validation.email',
};

const rules = {
  required: (value: string) => {
    if (isEmpty(value) && !isDate(value)) {
      return false;
    }

    if (isArray(value)) {
      return value.length !== 0;
    }

    if (isDate(value)) {
      return true;
    }

    return true;
  },
  email: (value: string) => emailValidation(value),
  number: (value: string) => !isNaN(parseInt(value, 10)),
};

export const getFieldRule = (rule: 'required' | 'email' | 'number', t: TFunction): RegisterOptions => {
  return {
    validate: (value: string) => rules[rule](value) || t(messages[rule]),
  };
};
